export default __webpack_public_path__ + "static/media/development.242fee02.svg";